<template>
	<v-container fluid>
	  <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-autocomplete
        	:items="planteles"
          v-model="editedItem.id_plantel"
          label="Plantel"
          filled
          readonly
          hide-details
          dense
          item-text="plantel"
          item-value="id_plantel"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-autocomplete
        	:items="ciclos"
          v-model="editedItem.id_ciclo"
          label="Ciclo"
          filled
          readonly
          hide-details
          dense
          item-text="ciclo"
          item-value="id_ciclo"
        ></v-autocomplete>
      </v-col>
	  </v-row>

	  <v-row>
    	<v-col 
    		cols="12" 
    		v-for="(grupo, i) in gruposSeleccionados"
    		:key="i"
    	>

    		<v-card class="shadowCard">
    		  <v-card-title primary-title>
    		    {{ grupo.name_salon || grupo.salon }} — {{ grupo.label || grupo.inicio }}
    		  </v-card-title>
    		  <v-card-text>
    		  	<v-row>
				      <v-col cols="12" md="6">
				        <v-autocomplete
				        	:items="filterCursos"
				          v-model="grupo.id_curso"
				          label="Curso"
				          outlined
				          hide-details
				          dense
				          item-text="curso"
				          item-value="id_curso"
				          @change="updateGrupo(grupo)"
				        ></v-autocomplete>
				      </v-col>


				      <v-col cols="12" md="6">
				        <v-autocomplete
				        	:items="horarios"
				          v-model="grupo.id_horario"
				          label="Horario"
				          outlined
				          hide-details
				          dense
				          item-text="horario"
				          item-value="id_horario"
				          @change="updateGrupo(grupo)"
				        ></v-autocomplete>
				      </v-col>

				      <v-col cols="12" md="6">
				        <v-autocomplete
				        	:items="salonesParaGrupo(grupo)"
				          v-model="grupo.id_salon"
				          label="Salon"
				          outlined
				          hide-details
				          dense
				          item-text="salon_label"
				          item-value="id_salon"
				          @change="updateGrupo(grupo)"
				        ></v-autocomplete>
				      </v-col>

				      <v-col cols="12" md="6">
				        <v-autocomplete
				        	:items="niveles"
				          v-model="grupo.id_nivel"
				          label="Nivel"
				          outlined
				          hide-details
				          dense
				          item-text="nivel"
				          item-value="id_nivel"
				          @change="updateGrupo(grupo)"
				        ></v-autocomplete>
				      </v-col>
    		  	</v-row>
    		    
    		  </v-card-text>
    		</v-card>
      </v-col>


    </v-row>

	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
	import { mapGetters } from 'vuex'
  import salonesDisponibles from '@/mixins/salonesDisponibles'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  export default {

  	mixins: [ salonesDisponibles ],

  	components:{
      Alerta,
      carga,
    },

  	props:[
			'editedItem',
			'idciclo',
			'plantel',
			'gruposSeleccionados',
			'gruposOcupacion',
			'horariosCatalog'
	  ],
    data: () => ({

    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      ciclos:[],
			salones:[],
			cursos:[],
			planteles:[],
			horarios:[],
			niveles:[],
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP']),

      filterCursos () {
        if (!this.plantel) {
          return []
        }
        const plantelObj = this.planteles.find(el => el.id_plantel == this.plantel)
        const nombre = plantelObj ? plantelObj.plantel : ''
        if (nombre.match('ONLINE')) {
          return this.cursos.filter(el => el.curso.match('ONLINE') || el.curso.match('CAMBIO') || el.curso.match('EXCI'))
        }
        return this.cursos.filter(el => !el.curso.match('ONLINE'))
      }
    },

    async created () {
    	this.editedItem.id_ciclo   = this.idciclo.id_ciclo
    	this.editedItem.id_plantel = this.plantel
    	this.editedItem.activo_sn  = 1

      await Promise.all([
			  this.getCiclos(),
			  this.getSalones(),
			  this.getCursos(),
			  this.getPlanteles(),
			  this.getHorarios(),
			  this.getNiveles(),
			])

      this.inicializarSeleccionados()
    },

    methods: {

      normalizeTime (str) {
        const [h = '00', m = '00'] = String(str || '').split(':')
        return `${h.padStart(2, '0')}:${m.padStart(2, '0')}`
      },

      matchHorario (inicio, fin) {
        if (!inicio || !fin) {
          return null
        }
        const ini = this.normalizeTime(inicio)
        const end = this.normalizeTime(fin)
        return this.horarios.find(h =>
          this.normalizeTime(h.hora_inicio) === ini &&
          this.normalizeTime(h.hora_fin) === end
        )
      },

      inicializarSeleccionados () {
        for (const grupo of this.gruposSeleccionados) {
          if (!grupo.id_plantel) {
            grupo.id_plantel = this.plantel
          }
          if (!grupo.id_ciclo) {
            grupo.id_ciclo = this.idciclo.id_ciclo
          }
          if (!grupo.id_nivel) {
            grupo.id_nivel = 1
          }
          if (!grupo.activo_sn) {
            grupo.activo_sn = 1
          }
          if (!grupo.id_horario && grupo.inicio && grupo.fin) {
            const horario = this.matchHorario(grupo.inicio, grupo.fin)
            if (horario) {
              grupo.id_horario = horario.id_horario
            }
          }
          if (!grupo.cupo && grupo.capacidad) {
            grupo.cupo = grupo.capacidad
          }
        }
      },

      salonesParaGrupo (grupo) {
        const catalog = this.horariosCatalog || this.horarios || []
        const h = catalog.find(x => x.id_horario == grupo.id_horario)
        const grupoRef = {
          ...grupo,
          hora_inicio: grupo.hora_inicio || (h && h.hora_inicio) || grupo.inicio,
          hora_fin: grupo.hora_fin || (h && h.hora_fin) || grupo.fin
        }

        return this.filterSalonesDisponibles({
          salones: this.salones,
          idPlantel: grupo.id_plantel || this.plantel,
          idCiclo: grupo.id_ciclo || (this.idciclo && this.idciclo.id_ciclo),
          idHorario: grupo.id_horario,
          idSalonActual: grupo.id_salon,
          grupos: this.gruposParaOcupacion(grupo),
          excludeGrupoId: null,
          horariosCatalog: catalog,
          grupoRef
        })
      },

      gruposParaOcupacion (grupoActual) {
        const base = [...(this.gruposOcupacion || [])]
        const catalog = this.horariosCatalog || this.horarios

        for (const sel of (this.gruposSeleccionados || [])) {
          if (sel === grupoActual || !sel.id_salon || !sel.id_horario) continue
          const h = catalog.find(x => x.id_horario == sel.id_horario)
          base.push({
            id_grupo: `pend-${sel.dia}-${sel.inicio}-${sel.id_salon}`,
            id_plantel: sel.id_plantel || this.plantel,
            id_ciclo: sel.id_ciclo || (this.idciclo && this.idciclo.id_ciclo),
            id_horario: sel.id_horario,
            id_salon: sel.id_salon,
            activo_sn: 1,
            dia: sel.dia,
            hora_inicio: h ? h.hora_inicio : sel.inicio,
            hora_fin: h ? h.hora_fin : sel.fin
          })
        }

        return base
      },

    	async save () {
        if (!this.gruposSeleccionados.length) {
          return this.validarErrorDirecto('No hay salones seleccionados')
        }

        const incompletos = this.gruposSeleccionados.filter(g =>
          !g.id_curso || !g.id_horario || !g.id_salon || !g.id_nivel
        )
        if (incompletos.length) {
          return this.validarErrorDirecto('Completa curso, horario, salón y nivel en todos los grupos')
        }

        this.cargar = true
        let ultimoMensaje = ''

        try {
          for (const grupo of this.gruposSeleccionados) {
            const payload = this.buildPayload(grupo)
            const response = await this.$http.post('grupos.add', payload)
            if (response.data && response.data.message) {
              ultimoMensaje = response.data.message
            }
          }
          this.validarSuccess(ultimoMensaje || 'Grupos creados correctamente')
          this.$emit('saved')
          this.$emit('click')
        } catch (error) {
          this.validarError(error.response && error.response.data ? error.response.data.message : error.message)
        } finally {
          this.cargar = false
        }
      },

      buildPayload (grupo) {
        const plantelObj = this.planteles.find(el => el.id_plantel == (grupo.id_plantel || this.plantel))
        const cicloObj = this.ciclos.find(el => el.id_ciclo == (grupo.id_ciclo || this.idciclo.id_ciclo))
        const horarioObj = this.horarios.find(el => el.id_horario == grupo.id_horario)
        const nivelObj = this.niveles.find(el => el.id_nivel == grupo.id_nivel)
        const cursoObj = this.cursos.find(el => el.id_curso == grupo.id_curso)

        const plantel = plantelObj ? plantelObj.plantel.trim() : ''
        const ciclo = cicloObj ? cicloObj.ciclo.trim() : ''
        const horario = horarioObj ? horarioObj.horario.trim() : ''
        const nivel = nivelObj ? nivelObj.nivel.trim() : ''

        return {
          id_plantel: grupo.id_plantel || this.plantel,
          id_ciclo: grupo.id_ciclo || this.idciclo.id_ciclo,
          id_curso: grupo.id_curso,
          id_horario: grupo.id_horario,
          id_salon: grupo.id_salon,
          id_nivel: grupo.id_nivel,
          activo_sn: 1,
          cupo: grupo.cupo || grupo.capacidad || 20,
          disponibles: grupo.cupo || grupo.capacidad || 20,
          precio: cursoObj ? cursoObj.precio_nivel : 0,
          grupo: `${plantel} - ${ciclo} - ${horario} - ${nivel}`,
          id_usuario: this.getdatosUsuarioERPERP.iderp,
          comentarios: '',
          origen: 'planeacion'
        }
      },

      getCiclos () {
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      getSalones () {
        this.salones = []
        return this.$http.get('salones.activos').then(response=>{
        	this.salones = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      getCursos () {
        this.cursos = []
        return this.$http.get('cursoserp.activos').then(response=>{
        	this.cursos = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      getPlanteles () {
        this.planteles = []
        return this.$http.get('planteles.activos').then(response=>{
        	this.planteles = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      getHorarios () {
        this.horarios = []
        return this.$http.get('horarios.activos').then(response=>{
        	this.horarios = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      getNiveles () {
        this.niveles = []
        return this.$http.get('niveles.activos').then(response=>{
        	this.niveles = response.data
        }).catch( error =>{
          this.validarError( error.response && error.response.data ? error.response.data.message : error.message )
        })
      },

      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true 
      },

      validarError ( value ) {
        this.cargar = false 
        const mensaje = typeof value === 'string'
          ? value
          : (value && value.body && value.body.message) || (value && value.message) || 'Error'
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta = true 
      },

      validarErrorDirecto ( mensaje ) {
        this.cargar = false 
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true 
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta = true 
    	},

    	updateGrupo( grupo ){
        const cursoObj = this.cursos.find(el => el.id_curso == grupo.id_curso)
        if (cursoObj) {
          grupo.precio = cursoObj.precio_nivel
        }
    	}
    },
  }
</script>
